import { Component, Input, OnChanges, SimpleChanges, OnInit } from '@angular/core';

import { ICampaignChart, IGeoCampaign } from '../dasboard-admin-chart-details.model';


@Component({
    moduleId: module.id,
    selector: 'campaign-chart',
    templateUrl: 'campaign-chart.component.html'
})

export class CampaingChartComponent implements OnInit, OnChanges {
    @Input() data: ICampaignChart;
    @Input() showCampaignOverlay: boolean;
    liveCampaignsCount: number;
    newThisWeek: number;
    geoCampaigns: Array<IGeoCampaign>;

    ngOnInit(){
        this.liveCampaignsCount = 0;
        this.newThisWeek = 0;
        this.geoCampaigns = new Array<IGeoCampaign>();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.data) {
            this.liveCampaignsCount = this.data.liveCampaignsCount;
            this.geoCampaigns = this.data.geoCampaigns;
            this.newThisWeek = this.data.newThisWeek;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/campaign/campaign-chart.component.ts